import React from "react";

import Typography from "@/components/Typography";
import Select from "@/components/Select";
import { OptionInterface } from "@/helpers/pageHelpers/Common/interface";

import styles from "./FiltersDropdown.module.scss";

interface SortInterface {
  options?: OptionInterface[];
  title?: string;
  onChange?: (value: string) => void;
}

const defaultOptions = [
  {
    name: "A - Z",
    value: "title-asc",
  },
  {
    name: "Z - A",
    value: "title-desc",
  },
  {
    name: " Od najnowszych",
    value: "published_at-desc",
  },
  {
    name: "Od najpopularniejszych",
    value: "popularity-desc",
  },
];

export const FiltersDropdown: React.FC<SortInterface> = ({
  options = defaultOptions,
  title = "Sortowanie:",
  onChange,
}) => (
  <div className={styles.wrapper}>
    <Typography variant="medium" className={styles.heading}>
      {title}
    </Typography>

    <Select
      initialSelected={options[0]}
      options={options}
      onChange={onChange}
    />
  </div>
);

export default FiltersDropdown;
